import axios from 'axios';

export const notificationMongoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/notification-mongo`,
    headers: {
        'Content-Type': 'application/json'
    }
})